import { TeaserLinkItemProps } from './types';
import Media from 'components/shared/Media/Media';
import { cn } from 'utils/styles';
import BaseTeaserLinkItem, { TeaserLinkContent } from './BaseTeaserLinkCard';

const ImageTeaserLink = ({ linkText, internalPage, url, image }: TeaserLinkItemProps) => {
  return (
    <BaseTeaserLinkItem
      url={url}
      internalPage={internalPage}
      className="dark-green-colorway in-cw-inverse:white-colorway">
      <div className={'w-full h-40 max-sm:xs:h-50'}>
        <Media
          media={{ ...image!, description: '' }}
          className={cn('rounded-b-none rounded-t-[8px] h-full w-full object-cover')}
        />
      </div>
      <TeaserLinkContent className="px-4 py-2">{linkText}</TeaserLinkContent>
    </BaseTeaserLinkItem>
  );
};

export default ImageTeaserLink;
